import { useEffect, useState } from 'react';

const formatElapsed = (ms) => {
	if (ms == null) return 'Refreshing…';
	const seconds = Math.max(0, Math.floor(ms / 1000));
	if (seconds < 60) return `Updated ${seconds}s ago`;
	const minutes = Math.floor(seconds / 60);
	const rem = seconds % 60;
	if (minutes < 60) return `Updated ${minutes}m ${rem}s ago`;
	const hours = Math.floor(minutes / 60);
	return `Updated ${hours}h ${minutes % 60}m ago`;
};

export const AutoRefreshStatus = ({ isAutoRefresh, lastRefreshedAt, compact = false }) => {
	const [now, setNow] = useState(Date.now());

	useEffect(() => {
		if (!isAutoRefresh) return;
		const id = setInterval(() => setNow(Date.now()), 1000);
		return () => clearInterval(id);
	}, [isAutoRefresh]);

	if (!isAutoRefresh) return null;

	const elapsed = lastRefreshedAt ? now - lastRefreshedAt : null;
	const text = formatElapsed(elapsed);

	return (
		<div
			style={{
				display: 'flex',
				alignItems: 'center',
				gap: 6,
				marginTop: compact ? 2 : 4,
				fontSize: compact ? 10 : 11,
				color: '#9ca3af',
				lineHeight: 1,
				userSelect: 'none',
			}}>
			<span
				aria-hidden="true"
				style={{
					display: 'inline-block',
					width: 7,
					height: 7,
					borderRadius: '50%',
					backgroundColor: '#22c55e',
					boxShadow: '0 0 0 0 rgba(34,197,94,0.7)',
					animation: 'auto-refresh-pulse 1.6s ease-out infinite',
				}}
			/>
			<span>{text}</span>
			<style>{`
				@keyframes auto-refresh-pulse {
					0% { box-shadow: 0 0 0 0 rgba(34,197,94,0.7); }
					70% { box-shadow: 0 0 0 6px rgba(34,197,94,0); }
					100% { box-shadow: 0 0 0 0 rgba(34,197,94,0); }
				}
			`}</style>
		</div>
	);
};
